import { render, staticRenderFns } from "./RingsEditOrderModal.vue?vue&type=template&id=641ddc59&scoped=true"
import script from "./RingsEditOrderModal.vue?vue&type=script&lang=ts"
export * from "./RingsEditOrderModal.vue?vue&type=script&lang=ts"
import style0 from "./RingsEditOrderModal.vue?vue&type=style&index=0&id=641ddc59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641ddc59",
  null
  
)

export default component.exports